export const enumToTuple = <T, V extends T[keyof T]>(enumObj: T): [string, V][] => {
    return Object.keys(enumObj)
        .filter((key) => isNaN(Number(key)))
        .map((key) => [key, enumObj[key] as V] as [string, V]);
};

export const includesEnumValue = <T extends object>(values: string[], enumObj: T): boolean => {
    const enumVals = Object.values(enumObj);
    return values.some((v) => enumVals.includes(v));
};
